import { render, staticRenderFns } from "./ProjectImages.vue?vue&type=template&id=5639a943&"
import script from "./ProjectImages.vue?vue&type=script&lang=js&"
export * from "./ProjectImages.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports